export const oktaConfig = {
    clientId: process.env.GATSBY_OKTA_CLIENT_ID,
    issuer: process.env.GATSBY_OKTA_ISSUER,
    redirectUri: process.env.GATSBY_OKTA_REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
  };
  